import { useDidMountEffect } from '@/app/hooks/useLifecycleEffects'
import { useRectObserver } from '@/app/hooks/useRectObserver'

type UseRectObserver<T> = {
  headerHeight: number
  setHeaderRef: (ref: (T & HTMLElement) | null) => void
  beforeContentHeight: number
  setBeforeContentRef: (ref: (T & HTMLElement) | null) => void
  footerHeight: number
  setFooterRef: (ref: (T & HTMLElement) | null) => void
  contentHeight: string
}

export const useDrawerRectObserver = <T>(): UseRectObserver<T> => {
  const {
    elementHeight: headerHeight,
    setElementRef: setHeaderRef,
    ping: pingHeaderRef
  } = useRectObserver<T>()
  const {
    elementHeight: beforeContentHeight,
    setElementRef: setBeforeContentRef,
    ping: pingBeforeContentRef
  } = useRectObserver<T>()
  const {
    elementHeight: footerHeight,
    setElementRef: setFooterRef,
    ping: pingFooterRef
  } = useRectObserver<T>()

  useDidMountEffect(() => {
    pingHeaderRef()
    pingBeforeContentRef()
    pingFooterRef()
  })

  const contentHeight = `calc(100vh - ${
    headerHeight + beforeContentHeight + footerHeight
  }px)`

  return {
    headerHeight,
    setHeaderRef,
    beforeContentHeight,
    setBeforeContentRef,
    footerHeight,
    setFooterRef,
    contentHeight
  }
}
